import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface MainContentWrapperProps {
  children: ReactNode;
  className?: string;
  variant?: "default" | "full" | "compact";
}

export function MainContentWrapper({ 
  children, 
  className, 
  variant = "default" 
}: MainContentWrapperProps) {
  const variants = {
    // Standard layout with generous padding for most pages
    default: "w-full md:max-w-4xl lg:max-w-4xl xl:max-w-4xl 2xl:max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6",
    // Full-width layout with minimal constraints for document viewers
    full: "w-full mx-auto px-3 xs:px-4 sm:px-6 py-3 xs:py-4",
    // Compact layout with tighter spacing for dialogs/modals
    compact: "w-full md:max-w-2xl lg:max-w-4xl xl:max-w-5xl mx-auto px-3 xs:px-4 sm:px-6 py-2 xs:py-3"
  };

  return (
    <div className={cn(variants[variant], className)}>
      {children}
    </div>
  );
}